import React, { useState } from "react";
import "./NavBar.css";

import logo from "../assets/logo2.png";
import logo1 from "../assets/logo.png";

const NavBar = () => {
  const [navBar, setnavBar] = useState(false);

  let Links = [
    { name: "Solutions", link: "/#solutions" },
    { name: "About Us", link: "/#team_div" },
    { name: "Contact", link: "mailto:hello@thenewschain.co" },
  ];
  let [open, setOpen] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 10) {
      setnavBar(true);
    } else {
      setnavBar(false);
    }
  };

  window.addEventListener("scroll", changeNav);

  return (
    <>
      <div
        id="nav"
        className={
          navBar
            ? "w-full fixed top-0 left-0 shadow-md z-20 navbar-active"
            : "w-full fixed top-0 left-0 shadow-none z-10 navbar"
        }
      >
        <div className="md:flex items-center justify-between py-4 md:px-20 px-7">
          <div
            className={`font-bold text-2xl cursor-pointer flex items-center ${
              navBar ? "text-gray-800" : "text-white"
            }`}
          >
            <img
              src={navBar ? logo1 : logo}
              alt="logo"
              height={50}
              width={150}
            />
          </div>

          <div
            onClick={() => setOpen(!open)}
            className={`text-3xl absolute right-8 top-6 cursor-pointer md:hidden ${
              navBar ? "text-black" : "text-white"
            }`}
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </div>

          <ul
            className={`md:flex md:items-center md:pb-0 pb-12 md:bg-transparent bg-white absolute md:static md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 mx-0 transition-all duration-100 ease-in ${
              open ? "top-20 " : "top-[-490px]"
            } md:px-0 px-8`}
          >
            {Links.map((link) => (
              <li key={link.name} className="md:ml-8 text-xl md:my-0 my-7">
                <a
                  href={link.link}
                  className={`duration-500 ${
                    navBar || open
                      ? "text-gray-800 hover:text-gray-400"
                      : "text-white hover:text-gray-300"
                  }`}
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default NavBar;
